<div class="w-100">
  <h1 class="head1">Help and Support</h1>
</div>
<div class="row mb-3">
  <div class="col-md-12">
    <div class="card shadow-sm p-3">
      <h6 class="mb-3 fw-600">Get Assistance with Metrium Dynamics</h6>
      <p>
        Need help or have questions about Metrium Dynamics? Our dedicated
        support team is here to assist you every step of the way. Whether you're
        experiencing technical issues, have billing inquiries, or need guidance
        on using our platform, we're here to help you succeed.
      </p>
    </div>
  </div>
</div>
<div class="row mb-3">
  <div class="col-md-12">
    <div class="card shadow-sm p-3">
      <h6 class="mb-3 fw-600">Contact Us</h6>
      <p>
        For any general queries or questions, please contact us at
        <strong>{{ contactDetails.SupportEmail || "N/A" }}</strong>
      </p>
      <!--<p>Email: {{ contactDetails.SupportEmail || "N/A" }}</p>
      <p>Phone: {{ contactDetails.SupportPhone || "N/A" }}</p>
      <p>Address: {{ contactDetails.SupportAddress || "N/A" }}</p>-->
    </div>
  </div>
</div>
<div class="row mb-3">
  <div class="col-md-12">
    <div class="card shadow-sm p-3">
      <h6 class="mb-3 fw-600">Business Hours</h6>
      <p>
        Our support team is available to assist you during the following hours:
        <strong>{{ contactDetails.SupportHours || "N/A" }}</strong>
      </p>
      <!--<p class="fw-600">{{ contactDetails.SupportHours || "N/A" }}</p>-->
    </div>
  </div>
</div>
